import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomNavigation from './BottomNavigation';
import { useGame } from '@/contexts/GameContext';
import ShareButton from '@/features/game/components/ShareButton';

interface AppShellProps {
  children?: React.ReactNode;
}

const AppShell: React.FC<AppShellProps> = ({ children }) => {
  const { gameState, isGameCompleted } = useGame();

  return (
    <div className='min-h-screen w-full bg-gray-50 dark:bg-gray-900 flex flex-col'>
      <header className='flex-shrink-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700'>
        <div className='flex items-center h-16 px-4 relative'>
          {/* Share button - only show when game is completed, positioned to the right */}
          {isGameCompleted && gameState && (
            <div className='absolute right-4'>
              <ShareButton
                won={gameState.gameOver.guessedWord}
                answer={gameState.correctWord}
                attempts={gameState.currentAttempt.attempt}
                validationGrid={gameState.boardValidationGrid}
                className="text-sm"
              />
            </div>
          )}
          
          {/* Centered title */}
          <h1 className='text-xl font-bold text-gray-900 dark:text-white brand-font flex-1 text-center'>
            Riddl
          </h1>
        </div>
      </header>
      <main className='flex-1 flex flex-col pb-16'>{children || <Outlet />}</main>
      <BottomNavigation />
    </div>
  );
};

export default AppShell;
